export default "data:image/gif;base64,R0lGODlhEgAMAPEBAP8AAP///+Xl5QAAACH5BAAAAAAALAAAAAASAAwAAAIalI+Jwe0fDJxN0mnvy7qCD4biSJbmiabqChYAOw=="